"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameWithRelsSchema = exports.GameSchema = void 0;
const zod_1 = require("zod");
const cycle_1 = require("./cycle");
const userGame_1 = require("./userGame");
exports.GameSchema = zod_1.z.object({
    cycle_id: zod_1.z.number(),
    behind_closed_doors: zod_1.z.boolean().nullable(),
    neutral_ground: zod_1.z.boolean(),
    week: zod_1.z.number().nullable(),
    game_id: zod_1.z.number(),
    attendance: zod_1.z.number().nullable(),
    stadium_id: zod_1.z.number().nullable(),
    away_team_id: zod_1.z.number(),
    home_team_id: zod_1.z.number(),
    round_id: zod_1.z.number().nullable(),
    play_status: zod_1.z.string().nullable(),
    weather: zod_1.z.string().nullable(),
    name: zod_1.z.string().nullable(),
    date: zod_1.z.string().nullable(),
    local_kick_off: zod_1.z.string().nullable(),
});
exports.GameWithRelsSchema = zod_1.z.object({
    cycle: cycle_1.CycleSchema,
    game: exports.GameSchema,
    user_game: userGame_1.UserGameSchema,
});
//# sourceMappingURL=game.js.map